import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import HeroImage from '../components/HeroImage'
import Banner from '../components/Banner'
import TC from '../components/forms/TC'
import MultiItemCarousel from '../components/partners/MultiItemCarousel';


const Terms = () => {
    return (
        <div>
            <Navbar />
            <HeroImage heading='Terms and Conditions' text='Africa Mining Summit Investment 2024 | Powered by Yep Group Mining' />
            <TC />
            <Banner />
            <MultiItemCarousel />
            <Footer />
        </div>
    )
}

export default Terms;
